import React, { PureComponent } from 'react';
import TableC from '../../../basicElement/TableC';

export default class List extends PureComponent {
    getColumns = () => ([{
        title: '排名',
        dataIndex: 'rank',
        key: 'rank',
        width: 60,
    }, {
        title: '带教老师姓名',
        dataIndex: 'userCompellation',
        key: 'userCompellation',
        width: 100,
        render: (text, record) => <a onClick={() => this.props.showDetail(record)}>{text}</a>
    }, {
        title: '带教老师工号',
        dataIndex: 'employeeCode',
        key: 'employeeCode',
        width: 100,
    }, {
        title: '职位/级别',
        dataIndex: 'positionName',
        key: 'positionName',
        width: 100,
    }, {
        title: '区域',
        dataIndex: 'areaName',
        key: 'areaName',
        width: 60,
    }, {
        title: '城市',
        dataIndex: 'workCityName',
        key: 'workCityName',
        width: 60,
    },  {
        title: '主管姓名',
        dataIndex: 'leaderUserCompellation',
        key: 'leaderUserCompellation',
        width: 100,
    },  {
        title: '主管工号',
        dataIndex: 'leaderEmployeeCode',
        key: 'leaderEmployeeCode',
        width: 100,
    }, {
        title: '总分',
        dataIndex: 'totalPoint',
        key: 'totalPoint',
        width: 60,
    }, {
        title: '主要业绩分',
        dataIndex: 'mainAchievementPoint',
        key: 'mainAchievementPoint',
        width: 60,
    }, {
        title: '减分',
        dataIndex: 'minusPoint',
        key: 'minusPoint',
        width: 60,
    }]);

    render() {
        const { data, meanValue, pagination, onChange } = this.props;
        return (
            <div>
                <div style={{ margin: '10px 0', fontWeight: 'bold' }}>均值：{meanValue}</div>
                <TableC
                        data={data}
                        pagination={pagination}
                        columns={this.getColumns()}
                        onChange={onChange}
                    />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/home/TeachingRank/components/List.js